import { ChevronLeft } from '@aktiia/design-system';
import { Link } from 'react-router-dom';

import { IHeaderProps } from './types';

export const Header = ({ backButton, rightButtons }: IHeaderProps) => (
  <header className="w-[calc(100%-240px)] h-[65px] fixed top-0 flex items-center justify-between py-4 px-6 border-b bg-background-base-primary border-border-divider z-10">
    <div className="flex w-full">
      {typeof backButton === 'object' && (
        <div className="flex items-center">
          <Link to={backButton.path} className="flex items-center">
            <ChevronLeft />
            <span className="typography-button-label-large text-text-primary ml-2">{backButton.title}</span>
          </Link>
        </div>
      )}
      <div className="flex-grow" />
      {rightButtons && <div className="flex items-center gap-4">{rightButtons}</div>}
    </div>
  </header>
);
